import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApplicationFacade } from '@ridango/components';
import { DropdownMenuData } from '@ridango/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'gl-mobile-dropdown-menu',
    templateUrl: './mobile-dropdown-menu.component.html',
    styleUrls: ['./mobile-dropdown-menu.component.scss']
})
export class MobileDropdownMenuComponent implements OnInit, OnDestroy {
    @Input() set isVisible(value: boolean) {
        this.isVisible$.next(value);
    }

    @Input() menuData: DropdownMenuData | null = null;

    private isVisible$ = new BehaviorSubject<boolean>(false);
    private destroy$ = new Subject<void>();

    isVisibleState$ = this.isVisible$.pipe(distinctUntilChanged(), takeUntil(this.destroy$));

    constructor(
        private applicationFacade: ApplicationFacade,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.applicationFacade.setMobileMenuOpen(false);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
